import {Button, Skeleton} from "antd";
import {CloseOutlined, ExclamationCircleFilled} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {LocationDto, LocationUserDto} from "../../../../generated/dashboard-client";
import LocationsApi from "../../../../api/LocationsApi";
import {env} from "../../../../env/env";
import {handleServerError} from "../../../../util/ErrorHandler";
import {TeamDrawer} from "../team/TeamDrawer";
import "../team/UserAccessDrawer.scss";

interface LocationUsersDrawerProps {
  location: LocationDto;
  onClose: () => void;
}

export function LocationUsersDrawer({location, onClose}: LocationUsersDrawerProps) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<LocationUserDto[]>([]);

  useEffect(() => {
    LocationsApi.getLocationUsers(location.internalId!)
      .then((resp) => setUsers(resp.data))
      .catch(handleServerError)
      .finally(() => setLoading(false));
  }, [location.internalId]);

  function reassign(user: LocationUserDto) {
    navigate(env.dashboardPath + `/account/team/user/${user.id}/locations`);
  }

  return (
    <TeamDrawer label={`${location.name} users`} onClose={onClose}>
      {(close) => <>
        <div className={"td-header"}>
          <div>
            <h4>{location.name}</h4>
            <p>Users with access to this location</p>
          </div>
          <button className={"td-close"} aria-label={"Close"} onClick={close}><CloseOutlined/></button>
        </div>

        <div className={"td-body"}>
          {loading && <Skeleton/>}
          {!loading && users.length === 0 && <div className={"td-empty"}>No users have access to this location</div>}
          {users.map((user) =>
            <div className={"access-row location-user-row"} key={user.id}>
              <div>
                <strong>{user.name}</strong>
                <span>{user.email}</span>
                {user.locationCount === 1 &&
                  <span className={"only-location-warning"}>
                    <ExclamationCircleFilled/> This is their only location. Reassign them before deleting it.
                  </span>}
              </div>
              {user.locationCount === 1 && <Button onClick={() => reassign(user)}>Reassign</Button>}
            </div>)}
        </div>
      </>}
    </TeamDrawer>
  );
}
